<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">
            <!-- <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a rouetLink="/mainview/dashboard" class="link">Dashboard</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page"> vendor Masters Management</li>
                    </ol>
                </nav>
            </div> -->
            <h4 class="page-title">Vendor Masters Management</h4>
        </div>

    </div>
</div>

<div style="display: block;Width:12%;margin-left: 30px;" *ngIf="write==true">
    <div class="mt-3">
        <a *ngIf="!show" href="javascript:void(0)" (click)="addVendor()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Add </span>
        </a>
        <a *ngIf="show" href="javascript:void(0)" (click)="addVendor()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Remove </span>
        </a>
    </div>
</div>

<div *ngIf="show">
    <div>

        <div class="container-fluid" style="margin-top: -19px;">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #vendor="ngForm" novalidate>
                                <div class="form-body">
                                    <h3 class="card-title"> Vendor</h3>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span> Account
                                                    Id
                                                </label>
                                                <select class="form-control" required #roleId="ngModel" name="roleId"
                                                    [(ngModel)]="vendorAddObj.accountId"
                                                    data-placeholder="Choose a Role Name" tabindex="1">
                                                    <option disabled="" value="" selected>Select Account</option>

                                                    <option *ngFor="let ual of userAccountsList" value="{{ual._id}}">
                                                        {{ual.emailAddress}}</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!roleId.errors.required"
                                                    *ngIf="roleId.errors && (roleId.touched || roleId.dirty)">*Please
                                                    select Account Id
                                                </span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Vendor
                                                    Name </label>
                                                <input type="text" id="vendorName" class="form-control" required
                                                    minlength="3" maxlength="30" #vendorName="ngModel" name="vendorName"
                                                    [(ngModel)]="vendorAddObj.vendorName" placeholder="Vendor Name"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                                    minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!vendorName.errors.required"
                                                    *ngIf="vendorName.errors && (vendorName.touched || vendorName.dirty)">
                                                    *This Field is Required</span>
                                                <span class="text-danger" [hidden]="!vendorName.errors?.pattern"
                                                    *ngIf="vendorName.errors && (vendorName.touched || vendorName.dirty)">
                                                    Vendor Name Should Be Only Alphabets</span>
                                                <span class="text-danger"
                                                    [hidden]="!vendorName.errors?.minlength || vendorName.errors.pattern"
                                                    *ngIf="vendorName.errors && (vendorName.touched || vendorName.dirty)">Vendor
                                                    Name Should Be Min 3 Characters</span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>
                                    <label class="control-label"> <span class="text-danger">*</span> Vendor
                                        Description</label>
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class="form-group">
                                                <input type="text" id="vendorDescription" required
                                                    #vendorDescription="ngModel" name="vendorDescription"
                                                    [(ngModel)]="vendorAddObj.vendorDescription" class="form-control"
                                                    rows="4">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!vendorDescription.errors.required"
                                                    *ngIf="vendorDescription.errors && (vendorDescription.touched || vendorDescription.dirty)">
                                                    This Field is Required</span>

                                            </div>
                                        </div>
                                    </div>
                                    <!--/row-->
                                    <div class="row">
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Category Name</label>
                                                <select class="form-control" #categoryId="ngModel"
                                                    (change)="getSubCategoryByCategoryId(vendorAddObj.category)"
                                                    name="categoryId" [(ngModel)]="vendorAddObj.category"
                                                    data-placeholder="Choose a Role Name" tabindex="1">
                                                    <option disabled="" value="" selected>Category</option>

                                                    <option *ngFor="let cl of categoriesList" value="{{cl.name}}">
                                                        {{cl.name}}</option>
                                                    <option value="Others">Others</option>
                                                </select>
                                                <span class="text-danger" [hidden]="!categoryId.errors.required"
                                                    *ngIf="categoryId.errors && (categoryId.touched || categoryId.dirty)">*Please
                                                    select Category
                                                </span>
                                                <br>

                                                <input type="text" id="otherCategory" required *ngIf="showTextField"
                                                    #otherCategory="ngModel" name="otherCategory"
                                                    placeholder="Enter category Name"
                                                    [(ngModel)]="vendorAddObj.otherCategory" class="form-control"
                                                    rows="4">
                                            </div>
                                        </div>
                                        <!--/span-->
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Sub Category Name</label>
                                                <select class="form-control" #subCategoryId="ngModel"
                                                    (change)="checking(vendorAddObj.subCategory)"
                                                    name="subCategoryId" [(ngModel)]="vendorAddObj.subCategory"
                                                    data-placeholder="Choose a Sub Category" tabindex="1">
                                                    <option disabled="" value="" selected>Sub Category</option>

                                                    <option *ngFor="let scl of subCategoriesList" value="{{scl.name}}">
                                                        {{scl.name}}</option>
                                                    <option value="Others">Others</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!subCategoryId.errors.required"
                                                    *ngIf="subCategoryId.errors && (subCategoryId.touched || subCategoryId.dirty)">*Please
                                                    select Sub Category
                                                </span>
                                                <br>
                                                <input type="text" id="otherSubCategory" required
                                                    *ngIf="showSubTextField" #otherSubCategory="ngModel"
                                                    name="otherSubCategory" placeholder="Enter Sub Category Name"
                                                    [(ngModel)]="vendorAddObj.otherSubCategory" class="form-control"
                                                    rows="4">
                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                    <div class="row">
                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Vendor
                                                    Company Name
                                                </label>
                                                <input type="text" id="vendorCompany" class="form-control" required
                                                    minlength="3" maxlength="30" #vendorCompany="ngModel"
                                                    name="vendorCompany" [(ngModel)]="vendorAddObj.vendorCompany"
                                                    placeholder="Vendor Company Name"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                                    minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!vendorCompany.errors.required"
                                                    *ngIf="vendorCompany.errors && (vendorCompany.touched || vendorCompany.dirty)">
                                                    *This Field is Required</span>
                                                <span class="text-danger" [hidden]="!vendorCompany.errors?.pattern"
                                                    *ngIf="vendorCompany.errors && (vendorCompany.touched || vendorCompany.dirty)">
                                                    Vendor Company Name Should Be Only Alphabets</span>
                                                <span class="text-danger"
                                                    [hidden]="!vendorCompany.errors?.minlength || vendorCompany.errors.pattern"
                                                    *ngIf="vendorCompany.errors && (vendorCompany.touched || vendorCompany.dirty)">
                                                    Vendor Company Name Should Be Min 3 Characters</span>
                                            </div>
                                        </div>

                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Vendor
                                                    GSTIN
                                                </label>
                                                <input type="text" id="vendorGSTIN" class="form-control" required
                                                    minlength="10" maxlength="50" #vendorGSTIN="ngModel"
                                                    name="vendorGSTIN" [(ngModel)]="vendorAddObj.vendorGSTIN"
                                                    placeholder="Vendor GSTIN" minlength="3" maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!vendorGSTIN.errors.required"
                                                    *ngIf="vendorGSTIN.errors && (vendorGSTIN.touched || vendorGSTIN.dirty)">
                                                    *This Field is Required</span>

                                                <span class="text-danger"
                                                    [hidden]="!vendorGSTIN.errors?.minlength || vendorGSTIN.errors.pattern"
                                                    *ngIf="vendorGSTIN.errors && (vendorGSTIN.touched || vendorGSTIN.dirty)">
                                                    Vendor GSTIN Should Be Min 3 Characters</span>
                                            </div>
                                        </div>

                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                    <!--/row-->
                                    <div class="row">
                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Vendor
                                                    Location
                                                </label>
                                                <input type="text" id="vendorLocation" class="form-control" required
                                                    minlength="3" maxlength="30" #vendorLocation="ngModel"
                                                    name="vendorLocation" [(ngModel)]="vendorAddObj.vendorLocation"
                                                    placeholder="Vendor Location"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                                    minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!vendorLocation.errors.required"
                                                    *ngIf="vendorLocation.errors && (vendorLocation.touched || vendorLocation.dirty)">
                                                    *This Field is Required</span>
                                                <span class="text-danger" [hidden]="!vendorLocation.errors?.pattern"
                                                    *ngIf="vendorLocation.errors && (vendorLocation.touched || vendorLocation.dirty)">
                                                    Vendor Location Should Be Only Alphabets</span>
                                                <span class="text-danger"
                                                    [hidden]="!vendorLocation.errors?.minlength || vendorLocation.errors.pattern"
                                                    *ngIf="vendorLocation.errors && (vendorLocation.touched || vendorLocation.dirty)">
                                                    Vendor Location Should Be Min 3 Characters</span>
                                            </div>
                                        </div>

                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Vendor
                                                    Address
                                                </label>
                                                <input type="text" id="vendorAddress" class="form-control" required
                                                    minlength="3" maxlength="30" #vendorAddress="ngModel"
                                                    name="vendorAddress" [(ngModel)]="vendorAddObj.vendorAddress"
                                                    placeholder="Vendor Address"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                                    minlength="3" maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!vendorAddress.errors.required"
                                                    *ngIf="vendorAddress.errors && (vendorAddress.touched || vendorAddress.dirty)">
                                                    *This Field is Required</span>

                                                <span class="text-danger"
                                                    [hidden]="!vendorAddress.errors?.minlength || vendorAddress.errors.pattern"
                                                    *ngIf="vendorAddress.errors && (vendorAddress.touched || vendorAddress.dirty)">
                                                    Vendor Address Should Be Min 3 Characters</span>
                                            </div>
                                        </div>

                                        <!--/span-->
                                    </div>



                                </div>

                                <div class="form-actions m-t-40">
                                    <button type="submit" style="background-color: #353556;color:white" class="btn"
                                        (click)="saveVendor()" [disabled]="!vendor.valid">
                                        <i class="fa fa-check"></i> Submit</button> &nbsp;&nbsp;
                                    <button type="button" class="btn btn-dark" (click)="addVendor()"
                                        data-dismiss="modal">Cancel</button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>

        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
    </div>
</div>
<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <diV class="row">
                                <div class="col-md-10">
                                    <label>Vendor Masters Management</label>
                                </div>

                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>

                                </div>
                                <div class="col-md-1">

                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="exportTable()">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </diV>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                    <input type="radio" id="emailId" name="gender" [(ngModel)]="filterValueSelected"
                                        value="ei" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> Account Email Id &nbsp;&nbsp;
                                    <input type="radio" id="name" name="gender" [(ngModel)]="filterValueSelected"
                                        value="cn" (change)="applyCustomizedFilter()"> Company Name &nbsp;&nbsp;
                                    <input type="radio" id="vendorname" name="gender" [(ngModel)]="filterValueSelected"
                                        value="vn" (change)="applyCustomizedFilter()">Vendor Name&nbsp;&nbsp;
                                    <input type="radio" id="gstin " name="gender" [(ngModel)]="filterValueSelected"
                                        value="g" (change)="applyCustomizedFilter()"> GSTIN &nbsp;&nbsp;



                                </div>
                                <div style="margin-left: 820px">

                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>
                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">

                                        <ng-container matColumnDef="accountEmailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Email Id</th>
                                            <td *matCellDef="let row">
                                                {{row.accountEmailId}}
                                            </td>
                                        </ng-container>



                                        <ng-container matColumnDef="vendorName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Name</th>
                                            <td *matCellDef="let row">
                                                {{row.vendorName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="vendorDescription">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
                                            <td *matCellDef="let row">
                                                {{row.vendorDescription}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="category">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
                                            <td *matCellDef="let row">
                                                {{row.category}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="subCategory">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Category</th>
                                            <td *matCellDef="let row">
                                                {{row.subCategory}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="vendorCompany">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Company Name
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.vendorCompany}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="vendorGSTIN">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor GSTIN</th>
                                            <td *matCellDef="let row">
                                                {{row.vendorGSTIN}}
                                            </td>
                                        </ng-container>


                                        <ng-container matColumnDef="vendorLocation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Location</th>
                                            <td *matCellDef="let row">
                                                {{row.vendorLocation}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="vendorAddress">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Address</th>
                                            <td *matCellDef="let row">
                                                {{row.vendorAddress}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>User Status
                                            </th>
                                            <td *matCellDef="let row">
                                                <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date of Creation</th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfCreation|date}}
                                            </td>
                                        </ng-container>
                                       

                                        <ng-container matColumnDef="Actions">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>

                                            <td *matCellDef="let row">
                                                <p *ngIf="read==true  && delete!=true && write !=true "
                                                    style="color:#353556;font-family: initial;font-weight: 500;">You
                                                    didn't have permission for actions</p>

                                                <ul class="list-group list-group-flush"
                                                    *ngIf="write==true || delete==true">
                                                    <li class="list-group-item  friend-list mb-2">

                                                        <div class="dropdown show float-right list-block">
                                                            <a class="userDropdown" href="#" role="button"
                                                                style="margin-right: 115px;" id="userDropdown"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">
                                                                <button class="dropdown-item" data-toggle="modal"
                                                                    *ngIf="write==true" data-target="#responsive"
                                                                    (click)="getByVendorId(row._id)">
                                                                    <i class="fa fa-address-card"
                                                                        aria-hidden="true"></i>&nbsp;&nbsp;Edit</button>

                                                                <div *ngIf="write==true">
                                                                    <mat-slide-toggle
                                                                        (change)="onChange($event,row._id)"
                                                                        [checked]="row.status">
                                                                        <span *ngIf="row.status==false">
                                                                            In Active</span>
                                                                        <span *ngIf="row.status==true">
                                                                            Active</span>
                                                                    </mat-slide-toggle>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>


                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <mat-paginator style="margin-right:200px" [length]="100" [pageSize]="10"
                        [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<div id="responsive" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Edit Vendor Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #vendorUpdate="ngForm" novalidate>
                    <div class="form-body">
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span> Account
                                        Id
                                    </label>
                                    <select class="form-control" required #roleId="ngModel" name="roleId"
                                        [(ngModel)]="vendorUpdateObj.accountId" data-placeholder="Choose a Role Name"
                                        tabindex="1">
                                        <option disabled="" value="" selected>Role</option>

                                        <option *ngFor="let ual of userAccountsList" value="{{ual._id}}">
                                            {{ual.emailAddress}}</option>


                                    </select>
                                    <span class="text-danger" [hidden]="!roleId.errors.required"
                                        *ngIf="roleId.errors && (roleId.touched || roleId.dirty)">*Please
                                        select Role
                                    </span>
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Vendor
                                        Name </label>
                                    <input type="text" id="vendorName" class="form-control" required minlength="3"
                                        maxlength="30" #vendorName="ngModel" name="vendorName"
                                        [(ngModel)]="vendorUpdateObj.vendorName" placeholder="Vendor Name"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!vendorName.errors.required"
                                        *ngIf="vendorName.errors && (vendorName.touched || vendorName.dirty)">
                                        *This Field is Required</span>
                                    <span class="text-danger" [hidden]="!vendorName.errors?.pattern"
                                        *ngIf="vendorName.errors && (vendorName.touched || vendorName.dirty)">
                                        Vendor Name Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!vendorName.errors?.minlength || vendorName.errors.pattern"
                                        *ngIf="vendorName.errors && (vendorName.touched || vendorName.dirty)">Vendor
                                        Name Should Be Min 3 Characters</span>
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <label class="control-label"> <span class="text-danger">*</span> Vendor
                            Description</label>
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="form-group">
                                    <input type="text" id="vendorDescription" required #vendorDescription="ngModel"
                                        name="vendorDescription" [(ngModel)]="vendorUpdateObj.vendorDescription"
                                        class="form-control" rows="4">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!vendorDescription.errors.required"
                                        *ngIf="vendorDescription.errors && (vendorDescription.touched || vendorDescription.dirty)">
                                        This Field is Required</span>

                                </div>
                            </div>
                        </div>
                        <!--/row-->
                        <div class="row">
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Category
                                    </label>
                                    <input type="text" id="category" class="form-control" required minlength="3"
                                        maxlength="30" #category="ngModel" name="category"
                                        [(ngModel)]="vendorUpdateObj.category" placeholder="Category"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!category.errors.required"
                                        *ngIf="category.errors && (category.touched || category.dirty)">
                                        *This Field is Required</span>
                                    <span class="text-danger" [hidden]="!category.errors?.pattern"
                                        *ngIf="category.errors && (category.touched || category.dirty)">
                                        Category Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!category.errors?.minlength || category.errors.pattern"
                                        *ngIf="category.errors && (category.touched || category.dirty)">Category
                                        Should Be Min 3 Characters</span>
                                </div>
                            </div>
                            <!--/span-->
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Sub
                                        Category
                                    </label>
                                    <input type="text" id="subCategory" class="form-control" required minlength="3"
                                        maxlength="30" #subCategory="ngModel" name="subCategory"
                                        [(ngModel)]="vendorUpdateObj.subCategory" placeholder="Sub Category"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!subCategory.errors.required"
                                        *ngIf="subCategory.errors && (subCategory.touched || subCategory.dirty)">
                                        *This Field is Required</span>
                                    <span class="text-danger" [hidden]="!subCategory.errors?.pattern"
                                        *ngIf="subCategory.errors && (subCategory.touched || subCategory.dirty)">
                                        Sub Category Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!subCategory.errors?.minlength || subCategory.errors.pattern"
                                        *ngIf="subCategory.errors && (subCategory.touched || subCategory.dirty)">
                                        Sub Category Should Be Min 3 Characters</span>
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <!--/row-->
                        <div class="row">
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Vendor
                                        Company Name
                                    </label>
                                    <input type="text" id="vendorCompany" class="form-control" required minlength="3"
                                        maxlength="30" #vendorCompany="ngModel" name="vendorCompany"
                                        [(ngModel)]="vendorUpdateObj.vendorCompany" placeholder="Vendor Company Name"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!vendorCompany.errors.required"
                                        *ngIf="vendorCompany.errors && (vendorCompany.touched || vendorCompany.dirty)">
                                        *This Field is Required</span>
                                    <span class="text-danger" [hidden]="!vendorCompany.errors?.pattern"
                                        *ngIf="vendorCompany.errors && (vendorCompany.touched || vendorCompany.dirty)">
                                        Vendor Company Name Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!vendorCompany.errors?.minlength || vendorCompany.errors.pattern"
                                        *ngIf="vendorCompany.errors && (vendorCompany.touched || vendorCompany.dirty)">
                                        Vendor Company Name Should Be Min 3 Characters</span>
                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Vendor
                                        GSTIN
                                    </label>
                                    <input type="text" id="vendorGSTIN" class="form-control" required minlength="10"
                                        maxlength="50" #vendorGSTIN="ngModel" name="vendorGSTIN"
                                        [(ngModel)]="vendorUpdateObj.vendorGSTIN" placeholder="Vendor GSTIN"
                                        minlength="3" maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!vendorGSTIN.errors.required"
                                        *ngIf="vendorGSTIN.errors && (vendorGSTIN.touched || vendorGSTIN.dirty)">
                                        *This Field is Required</span>

                                    <span class="text-danger"
                                        [hidden]="!vendorGSTIN.errors?.minlength || vendorGSTIN.errors.pattern"
                                        *ngIf="vendorGSTIN.errors && (vendorGSTIN.touched || vendorGSTIN.dirty)">
                                        Vendor GSTIN Should Be Min 3 Characters</span>
                                </div>
                            </div>

                            <!--/span-->
                        </div>
                        <!--/row-->
                        <!--/row-->
                        <div class="row">
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Vendor
                                        Location
                                    </label>
                                    <input type="text" id="vendorLocation" class="form-control" required minlength="3"
                                        maxlength="30" #vendorLocation="ngModel" name="vendorLocation"
                                        [(ngModel)]="vendorUpdateObj.vendorLocation" placeholder="Vendor Location"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!vendorLocation.errors.required"
                                        *ngIf="vendorLocation.errors && (vendorLocation.touched || vendorLocation.dirty)">
                                        *This Field is Required</span>
                                    <span class="text-danger" [hidden]="!vendorLocation.errors?.pattern"
                                        *ngIf="vendorLocation.errors && (vendorLocation.touched || vendorLocation.dirty)">
                                        Vendor Location Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!vendorLocation.errors?.minlength || vendorLocation.errors.pattern"
                                        *ngIf="vendorLocation.errors && (vendorLocation.touched || vendorLocation.dirty)">
                                        Vendor Location Should Be Min 3 Characters</span>
                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Vendor
                                        Address
                                    </label>
                                    <input type="text" id="vendorAddress" class="form-control" required minlength="3"
                                        maxlength="30" #vendorAddress="ngModel" name="vendorAddress"
                                        [(ngModel)]="vendorUpdateObj.vendorAddress" placeholder="Vendor Address"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        minlength="3" maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!vendorAddress.errors.required"
                                        *ngIf="vendorAddress.errors && (vendorAddress.touched || vendorAddress.dirty)">
                                        *This Field is Required</span>

                                    <span class="text-danger"
                                        [hidden]="!vendorAddress.errors?.minlength || vendorAddress.errors.pattern"
                                        *ngIf="vendorAddress.errors && (vendorAddress.touched || vendorAddress.dirty)">
                                        Vendor Address Should Be Min 3 Characters</span>
                                </div>
                            </div>

                            <!--/span-->
                        </div>



                    </div>

                    <div class="form-actions m-t-40">
                        <button type="submit" style="background-color: #353556;color:white" class="btn"
                            (click)="updateVendor()" data-dismiss="modal" [disabled]="!vendorUpdate.valid">
                            <i class="fa fa-check"></i> Update</button> &nbsp;&nbsp;
                        <button type="button" class="btn btn-dark" data-dismiss="modal">Cancel</button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>